import { render, staticRenderFns } from "./StartTimeBubbleTv.vue?vue&type=template&id=2145e6a4&scoped=true&"
import script from "./StartTimeBubbleTv.vue?vue&type=script&lang=js&"
export * from "./StartTimeBubbleTv.vue?vue&type=script&lang=js&"
import style0 from "./StartTimeBubbleTv.vue?vue&type=style&index=0&id=2145e6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145e6a4",
  null
  
)

export default component.exports